import {
  EntrancePlantDetailDTO,
  EntrancePlantStructureCreateDTO,
  GateDTO,
} from '@/../client-generator/generated-clients/plants';
import plantsClient from '@/core/services/plants';
import { SET_APP_LOADING } from '@/core/store/action-types';
import NumberButtons from '@/views/components/NumberButtons/NumberButtons.vue';
import { PropType } from 'vue';
import { Options, Vue } from 'vue-class-component';
import { mapState } from 'vuex';

@Options({
  name: 'DialogRenameGate',
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
    gateToEdit: {
      type: Object as PropType<GateDTO>,
      required: false,
    },
  },
  computed: {
    ...mapState(['currentEntrancePlant']),
  },
  data() {
    return {
      isDialogVisible: false,
      isValidName: true,
      invalidNameReason: '',
      editedGate: {
        name: '',
      } as GateDTO,
    };
  },
  watch: {
    isVisible: function (newValue) {
      this.isDialogVisible = newValue;
      if (this.isDialogVisible) {
        this.invalidNameReason = '';
        this.isValidName = true;
        this.initGate();
      }
    },
    'editedGate.name'() {
      this.verifyValidityOfName();
    },
  },
  components: { NumberButtons },
  emits: ['hide-dialog', 'update-list'],
})
export default class DialogRenameGate extends Vue {
  gateToEdit!: GateDTO;
  editedGate!: GateDTO;
  currentEntrancePlant!: EntrancePlantDetailDTO;
  isVisible!: boolean;
  isDialogVisible = false;
  isValidName = true;
  invalidNameReason: string = '';
  testVar = GateDTO;

  mounted() {
    this.isDialogVisible = this.isVisible;
  }

  async initGate() {
    this.editedGate = new GateDTO();
    this.editedGate.gateId = this.gateToEdit.gateId;
    this.editedGate.name = this.gateToEdit.name;
    this.editedGate.apartments = this.gateToEdit.apartments;
    this.editedGate.connectedBuildingIds = this.gateToEdit.connectedBuildingIds;
    this.editedGate.connectedRiserIds = this.gateToEdit.connectedRiserIds;
    this.editedGate.devices = this.gateToEdit.devices;
    this.editedGate.scsAddress = this.gateToEdit.scsAddress;
  }

  async saveGate() {
    if (this.currentEntrancePlant.desktopId === undefined) return;
    try {
      await plantsClient.gatePUT(
        this.currentEntrancePlant.desktopId,
        this.gateToEdit.gateId!,
        this.editedGate
      );
    } catch (error) {
      console.log(error);
      setTimeout(() => {
        this.$toast.add({
          severity: 'error',
          summary: 'Error',
          closable: false,
          life: 3000,
        });
      }, 1500);
    }
  }

  async handleButtonSubmitAction() {
    this.isDialogVisible = false;
    this.$store.dispatch(SET_APP_LOADING, true);

    await this.saveGate();

    this.$store.dispatch(SET_APP_LOADING, false);

    this.$emit('update-list');
    this.$toast.add({
      severity: 'success',
      summary: this.$t('entrancePlant.gateBannerUpdated'),
      closable: false,
      life: 3000,
    });
  }

  verifyValidityOfName() {
    if (!this.editedGate.name && this.editedGate.name?.trim() === '') {
      this.isValidName = false;
      this.invalidNameReason = this.$t('general.emptyField');
      return;
    }
    let listToCheck = this.currentEntrancePlant.gates || [];

    listToCheck = listToCheck.filter(
      (editing) => editing.gateId !== this.gateToEdit.gateId
    );

    const exist = listToCheck.some(
      (existing) =>
        existing.name?.toLowerCase().trim() ==
        this.editedGate.name?.toLowerCase().trim()
    );
    this.isValidName = !exist;
    this.invalidNameReason = this.isValidName
      ? ''
      : this.$t('general.alreadyExisting');
  }

  doHideDialog() {
    this.$emit('hide-dialog');
  }

  handleCancelButton() {
    this.isDialogVisible = false;
  }
}
